import { render } from "./SixteenPeople.vue?vue&type=template&id=2e37235c&scoped=true"
import script from "./SixteenPeople.vue?vue&type=script&lang=js"
export * from "./SixteenPeople.vue?vue&type=script&lang=js"

import "./SixteenPeople.vue?vue&type=style&index=0&id=2e37235c&scoped=true&lang=css"

import exportComponent from "../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e37235c"]])

export default __exports__